import { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import {
  notification,
  Tour,
  Button,
  message,
  Space,
  Input,
  DatePicker,
  Tabs,
  Modal,
  Table,
  Upload,
  Select,
  Drawer,
  Row,
  Col,
  Divider,
  Form,
  Spin,
  Tooltip,
  Checkbox,
} from "antd";
import {
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  FileOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { usePapaParse } from "react-papaparse";
import Sidebar from "../../../Components/Backoffice/Sidebar";
import Card from "../../../Components/Backoffice/Card";
import Title from "../../../Components/Backoffice/Title";
import Header from "../../../Components/Backoffice/Header";
import Footer from "../../../Components/Backoffice/Footer";
import DrawerPerfil from "../../../Pages/Backoffice/Socios/drawerPerfil";
import { ReactComponent as IconSearch } from "../../../Assets/Images/Backoffice/Search.svg";
import { ReactComponent as IconOptions } from "../../../Assets/Images/Backoffice/Options.svg";
import { ReactComponent as IconUpload } from "../../../Assets/Images/Backoffice/Upload-off.svg";
import MBWayImage from "../../../Assets/Images/mbway_backoffice.svg";
import MBImage from "../../../Assets/Images/multibanco_backoffice.svg";
import MBImage1 from "../../../Assets/Images/Multibanco.png";
import axios from "axios";
import CardQuotes from "../../../Components/Backoffice/CardQuotes";
import { Link } from "react-router-dom";
import dayjs from 'dayjs';

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Highlighter from 'react-highlight-words';
import { displayName } from "react-quill";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);


const { TextArea } = Input;
const { Dragger } = Upload;
const { RangePicker } = DatePicker;
const { Search } = Input;

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: 7.083vw 1fr;
  min-height: 100vh;

  .ant-select-selection-overflow {
    height: inherit !important;
  }

  .p-15-0 {
    padding: 6px 0 0 0;
  }

  .export-btn {
    height: 45px;
    margin-left: 10px;
    padding: 0 30px;
  }

  .highlight-row {
  background: blue;
  }

  @media (max-width: 992px) {
  }

  .generate-receipt {
    color: blue !important;
  }

  .ant-select-selector {
    min-height: 46px !important;
    border-radius: 16px !important;
    color: rgb(134, 136, 168);
    font-size: 16px;
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 44px !important;
  }

  .ant-form-item {
    margin-bottom: 12px !important;
  }

  .table-success,
  .table-success:hover,
  .table-success:hover td {
    background-color: #ddffdd !important;
  }

  .table-danger,
  .table-danger:hover,
  .table-danger:hover td {
    background: #ffdddd !important;
  }

  .table-warning,
  .table-warning:hover,
  .table-warning:hover td {
    background: #ffffcc !important;
  }
`;

const Content = styled.div`
  padding: 1.771vw;

`;

const CardHeader = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto auto;
`;


const CardContent = styled.div`
  position: relative;

  table th {
    color: #809fb8 !important;
  }

  .ant-checkbox-checked span.ant-checkbox-inner,
  .ant-checkbox-checked:hover span.ant-checkbox-inner {
    background-color: #1ad598 !important;
    border-color: #1ad598 !important;
  }

  .ant-checkbox:hover span.ant-checkbox-inner,
  .ant-checkbox-wrapper.item__checkbox:hover .ant-checkbox-inner {
    border-color: #1ad598 !important;
  }

  .user-name {
    color: #494d7d;
  }

  .icon-upload {
    cursor: pointer;
    height: 46px;
    width: 46px;
  }

  .user-number {
    border-color: #d9e1e7cc;
    color: #809fb8;
    text-align: center;
  }

  .user-active {
    background-color: #1ad5984d;
    border: none;
    color: #1ad598;
  }

  .user-desactive {
    background-color: #ea3a3d4d;
    border: none;
    color: #ea3a3d;
  }

  .user-disabled {
    background-color: #d9e1e7;
    border: none;
    color: #99b2c6;
  }

  li.ant-pagination-item {
    border: 1px solid #d9e1e7cc;
  }

  li.ant-pagination-item.ant-pagination-item-active {
    background-color: #8688a8;
    border-color: #8688a8;
    color: #ffffff;
  }
`;

const TableFooter = styled.div`
  bottom: 16px;
  left: 0;
  position: absolute;
`;

const RadioGroup = styled.div`
  button {
    background-color: #494d7d;
    border: none;
    color: #ffffff;
    transition: 0.3s ease;
  }

  button:hover {
    background-color: #1ad598;
    color: #ffffff !important;
  }
`;

const UploadButtonStyle = styled.button`
  background-color: #494d7d;
  border: none;
  color: #ffffff;
  transition: 0.3s ease;
  font-size: 14px;
  height: 32px;
  padding: 4px 15px;
  border-radius: 6px;
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);

  :hover {
    background-color: #1ad598;
    color: #ffffff !important;
  }
`;

var styles = {
  h6_label: {
    color: "#809FB8",
    fontFamily: "Roboto",
    fontSize: "15px",
    marginTop: "1%",
  },
  input_class_disabled: {
    marginBottom: "2%",
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    opacity: 0.6,
    pointerEvents: "none",
  },
  input_class: {
    borderRadius: "6px",
    height: "45px",
    color: "#0C1151",
    width: "100%",
  },
  date_class: {
    borderRadius: "6px",
    padding: "0 10px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    width: "100%",
  },
  select_class: {
    height: "45px",
    color: "#0C1151",
    width: "100%",
    height: "46px",
  },
  textarea_class: {
    borderRadius: "6px",
    border: "1px solid #809FB8",
    color: "#0C1151",
  },
  switch_label: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "bold",
    height: "45px",
    borderRadius: "8px",
    padding: "0px 16px",
    color: "#809FB8",
    border: "1px solid #809FB8",
    textAlign: "center",
  },
  upload: {
    width: "100%",
  },
};

export default function Quotas(props) {
  document.title = "SPAP - Quotas";
  const { readString } = usePapaParse();
  const [form] = Form.useForm();

  const today = dayjs().format("YYYY-MM-DD");

  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalReceiptOpen, setIsModalReceiptOpen] = useState(false);
  const [isModalOutOfWebsiteOpen, setIsModalOutOfWebsiteOpen] = useState(false);
  const [isSaveQuotasModalOpen, setIsSaveQuotasModalOpen] = useState(false);
  const [quotaDataToEdit, setQuotaDataToEdit] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState({});
  const [userDrawer, setUserDrawer] = useState({});
  const [quotasBkp, setListaQuotasBkp] = useState([]);
  const [dataBkp, setDataBkp] = useState([]);
  const [open, setOpen] = useState(false);
  const [dataToShow, setDataToShow] = useState([]);
  const [lastPaymentsToShow, setLastPaymentsToShow] = useState([]);
  const [lastPaymentsToShowBkp, setLastPaymentsToShowBkp] = useState([]);
  const [listaQuotas, setListaQuotas] = useState([]);
  const [listUsersBkp, setListUsersBkp] = useState([]);
  const [fileRecibo, setfileRecibo] = useState([]);
  const [fileComprovativo, setfileComprovativo] = useState([]);
  const [fileNotaCredito, setfileNotaCredito] = useState([]);
  const [years, setYears] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [usersPendentQuotas, setUsersPendentQuotas] = useState([]);
  const searchInput = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm1, setSearchTerm1] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [dataPayment, setDataPayment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(25);

  const tableOnChange = (pagination, filters, sorter, extra) => {
    //console.log("params", pagination, filters, sorter, extra);
  };

  const selectHandleChange = (value) => {
    setTablePagination(value);
  };
  const t = 1;
  const data = [];
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const propReciboPDF = {
    onRemove: (file) => {
      const index = fileRecibo.indexOf(file);
      const newFileList = fileRecibo.slice();
      newFileList.splice(index, 1);
      setfileRecibo(newFileList);
    },
    beforeUpload: (file) => {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error(`${file.name} não é um ficheiro PDF`);
        setfileRecibo([]);
        return isPDF || Upload.LIST_IGNORE;
      }
      setfileRecibo([file]);
      return false;
    },
    fileRecibo,
  };

  const propNotaCreditoPDF = {
    onRemove: (file) => {
      const index = fileNotaCredito.indexOf(file);
      const newFileList = fileNotaCredito.slice();
      newFileList.splice(index, 1);
      setfileNotaCredito(newFileList);
    },
    beforeUpload: (file) => {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error(`${file.name} não é um ficheiro PDF`);
        setfileNotaCredito([]);
        return isPDF || Upload.LIST_IGNORE;
      }
      setfileNotaCredito([file]);
      return false;
    },
    fileNotaCredito,
  };

  const propComprovativoPDF = {
    onRemove: (file) => {
      const index = fileComprovativo.indexOf(file);
      const newFileList = fileComprovativo.slice();
      newFileList.splice(index, 1);
      setfileComprovativo(newFileList);
    },
    beforeUpload: (file) => {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error(`${file.name} não é um ficheiro PDF`);
        setfileComprovativo([]);
        return isPDF || Upload.LIST_IGNORE;
      }

      setfileComprovativo([file]);
      return false;
    },
    fileComprovativo,
  };

  function agruparPagamentos(lastpayments) {
    const grupos = new Map();
    const anoAtual = new Date().getFullYear();

    // Obter data atual formatada: "YYYY-MM-DD"
    const hoje = new Date().toISOString().slice(0, 10);

    lastpayments.forEach(item => {
      const chave = `${item.payment_valid_date}_${item.user_email}_${item.description}`;
      if (!grupos.has(chave)) {
        grupos.set(chave, []);
      }
      grupos.get(chave).push(item);
    });

    const resultado = [];

    for (const grupoOriginal of grupos.values()) {
      // Filtrar SPAP do ano passado
      const grupo = grupoOriginal.filter(item => {
        const ano = parseInt(item.ano);
        return true;
      });

      if (grupo.length === 0) continue;

      const base = { ...grupo[0] };

      const tipos = new Set(grupo.map(p => p.tipo));
      const anos = [...new Set(grupo.map(p => p.ano))];

      let totalValor = 0;
      let totalPaymentValue = 0;

      // Verificar se algum pagamento foi no dia atual
      const pagamentoNoDiaAtual = grupo.some(item => {
        const dataValidDate = item.payment_valid_date ? item.payment_valid_date.slice(0, 10) : null;
        const dataPaymentDate = item.payment_date ? item.payment_date.slice(0, 10) : null;

        return dataValidDate === hoje || dataPaymentDate === hoje;
      });

      grupo.forEach(item => {

        const valorNumerico = parseFloat(item.valor);
        const valorPresente = !isNaN(valorNumerico);

        if (valorPresente) {
          totalValor += valorNumerico;
        } else if (item.ano < anoAtual) {
          totalValor += 30;
        }

        const paymentVal = parseFloat(item.payment_value || 0);
        if (!isNaN(paymentVal)) {
          totalPaymentValue += paymentVal;
        }
      });

      // Formatar tipo
      if (grupo.length === 1) {
        base.tipo = `${base.tipo} ${base.ano}`;
      } else {
        if (anos.length === 1) {
          const tiposOrdenados = [...tipos].sort();
          base.tipo = `${tiposOrdenados.join(' + ')} ${anos[0]}`;
        } else {
          const tipoAnoList = grupo.map(p => `${p.tipo} ${p.ano}`);
          tipoAnoList.sort((a, b) => {
            const anoA = parseInt(a.split(' ')[1]);
            const anoB = parseInt(b.split(' ')[1]);
            return anoB - anoA;
          });
          base.tipo = tipoAnoList.join(', ');
        }
      }

      base.valor = totalValor.toString() + '€';
      base.payment_value = totalPaymentValue.toString();

      // Adiciona a nova variável no objeto final
      base.pagamentoNoDiaAtual = pagamentoNoDiaAtual;

      resultado.push(base);
    }

    return resultado;
  }

  const handleLastPayments = (data) => {
    let lastPayments = data.quotas.filter((quota) => {
      return quota.status == "pago"
    }).sort((a, b) => {
      const dateA = Date.parse(a.payment_valid_date);
      const dateB = Date.parse(b.payment_valid_date);
      const isValidA = !isNaN(dateA);
      const isValidB = !isNaN(dateB);
      if (isValidA && isValidB) {
        return dateB - dateA;
      }
      if (!isValidA && isValidB) return 1;
      if (isValidA && !isValidB) return -1;

      return 0;
    });

    lastPayments = agruparPagamentos(lastPayments);

    setLastPaymentsToShow(lastPayments);
    setLastPaymentsToShowBkp(lastPayments);
  }

  function gerarQuotasNaoPagasString(quotas) {
  const hoje = new Date();
  const mesAtual = hoje.getMonth();
  const anoAtual = hoje.getFullYear();
  const emDezembro = mesAtual === 11;

  const porAno = {};

  quotas
    .filter((q) => {
      if (q.status !== "nao pago") return false;
      if (q.tipo === "IAP") return false;

      if (q.tipo === "ESP") {
        return emDezembro
          ? q.ano === anoAtual + 1
          : q.ano === anoAtual;
      }

      const limiteAno = emDezembro ? anoAtual + 1 : anoAtual;
      return q.ano <= limiteAno;
    })
    .forEach((q) => {
      if (!porAno[q.ano]) porAno[q.ano] = new Set();
      porAno[q.ano].add(q.tipo);
    });

  if (Object.keys(porAno).length === 0) return "";

  return Object.entries(porAno)
    .sort((a, b) => b[0] - a[0])
    .map(([ano, tipos]) => `${Array.from(tipos).join(" + ")} ${ano}`)
    .join(", ");
}


  const handleUsersWithPendentQuotas = (data) => {
    const usersComQuotasNaoPagas = data
    .map((user) => {
      const quotasNaoPagas = gerarQuotasNaoPagasString(user.quotas);
      return quotasNaoPagas
        ? { ...user, quotasNaoPagas }
        : null; // se não tem quotas por pagar, marca como nulo
    })
    .filter(Boolean);

    setUsersPendentQuotas(usersComQuotasNaoPagas);
  }

  const checkUserQuotas = (user, quotas) => {
    if (user.tipo_socio === 'Honorário' || user.tipo_utilizador == "nao_socio") {
      return [];
    }

    // Data do registo
    let data = new Date(user.created_at);

    let ano = data.getUTCFullYear();
    let mes = data.getUTCMonth() + 1;

    // Se registado em dezembro → começa no ano seguinte
    let anoInicial = mes === 12 ? ano + 1 : ano;

    const agora = new Date();
    const anoAtual = agora.getUTCFullYear();
    const mesAtual = agora.getUTCMonth() + 1;

    const anoFinal = mesAtual === 12 ? anoAtual + 1 : anoAtual;

    // Conjunto de anos que existem nas quotas
    const anosExistentes = new Set(quotas.map(q => Number(q.ano)));

    // Aqui vamos guardar os anos que estão em falta
    let quotasPendentes = [];

      for (let a = anoInicial; a <= anoFinal; a++) {
        if (!anosExistentes.has(a)) {
          quotasPendentes.push(a);
        }
      }

    return quotasPendentes;
  };

  const getQuotasPendentes = (user, quotas) => {
    if (user.tipo_utilizador == 'nao_socio') {
      return [];
    }

    // Data do registo
    const data = new Date(user.created_at);
    const anoRegisto = data.getUTCFullYear();
    const mesRegisto = data.getUTCMonth() + 1;
    const anoInicial = mesRegisto === 12 ? anoRegisto + 1 : anoRegisto;

    // Ano final
    const agora = new Date();
    const anoAtual = agora.getUTCFullYear();
    const mesAtual = agora.getUTCMonth() + 1;
    const anoFinal = mesAtual === 12 ? anoAtual + 1 : anoAtual;

    // Mapa ano -> quotas desse ano
    const quotasPorAno = new Map();
    quotas.forEach(q => {
      const anoNum = Number(q.ano);
      if (!quotasPorAno.has(anoNum)) {
        quotasPorAno.set(anoNum, []);
      }
      quotasPorAno.get(anoNum).push(q);
    });

    const quotasPendentes = [];

    for (let ano = anoInicial; ano <= anoFinal; ano++) {
      const quotasAno = quotasPorAno.get(ano) || [];

      const spapPago = quotasAno.some(q => q.tipo == 'SPAP' && q.status == 'pago');
      const espPago = quotasAno.some(q => q.tipo == 'ESP' && q.status == 'pago');

      if (user.grau == 'Especialista') {
        if (!spapPago) {
          quotasPendentes.push({ ano: ano, tipo: 'SPAP', status: 'não pago' });
        }
        if (!espPago) {
          quotasPendentes.push({ ano: ano, tipo: 'ESP', status: 'não pago' });
        }
      } else if (user.grau == 'Interno') {
        if (!spapPago) {
          quotasPendentes.push({ ano: ano, tipo: 'SPAP', status: 'não pago' });
        }
      }
    }

    let quotasPorPagar = quotasPendentes.filter(item => {
      // Mantém todos os SPAP
      if (item.tipo === "SPAP") return true;

      // Para ESP: só deixa o do ano permitido
      if (item.tipo === "ESP" && (new Date().getMonth() >= 11 || new Date().getMonth() < 2)) {
        return item.ano === anoFinal;
      }

      return false;
    });

    if (user.tipo_socio == "Honorário") {
      quotasPorPagar = quotasPorPagar.filter(item => {
        return item.tipo === "ESP" && item.ano === anoFinal;
      });
    } else {
      quotasPorPagar = quotasPendentes.filter(item => {
        if (item.tipo === "SPAP") return true;            // mantém todos SPAP
        if (item.tipo === "ESP" && item.ano === anoFinal) {  // mantém ESP só do anoFinal
          return true;
        }
        return false;                                       // remove o resto
      });
    }

    return quotasPorPagar;
  };

  function nomeValido(nome_completo) {
    const palavras = nome_completo.trim().split(/\s+/);

    if (palavras.length <= 1) return false;

    // Verifica se todas as palavras são iguais
    const primeira = palavras[0].toLowerCase();
    const todasIguais = palavras.every(p => p.toLowerCase() === primeira);

    return !todasIguais;
  }


  const getQuotas = (data) => {
    let currentMonth = new Date().getMonth();
    let groupQuotasByUser = [];
    handleLastPayments(data);
    data.users.map((user) => {

      let quotasByUser = data.quotas.filter(function (quota) {
        return quota.userId == user.id;
      });

      let quotasNaoPagas = checkUserQuotas(user, quotasByUser);
      let observ = data.obs?.filter(function (observ) {
        return user.id == observ.user_id;
      });
      let newObs = "";
      if (observ.length) {
        newObs = observ[0].text;
      }
        quotasByUser?.sort((b, a) => a.ano - b.ano);
        let newname = "";
        if (user.nome_completo && nomeValido(user.nome_completo)) {
          newname = user.nome_completo;
        } else {
          newname = user.name;
          if (user.apelido != user.name) {
          newname += user.apelido ? " " + user.apelido : "";
          }
        }

        const updatedQuotas = quotasByUser.map(q => ({
          ...q,
          drawerName: newname
        })).filter((q) => q.status == 'pago');

        let quotasPendentes = getQuotasPendentes(user, updatedQuotas);



        const hoje = new Date();
        const mesAtual = hoje.getMonth(); // 0 = janeiro, 11 = dezembro
        const anoAtual = hoje.getFullYear();

        const anoReferencia = mesAtual === 11 ? anoAtual + 1 : anoAtual;

        const existeSPAPAtual = quotasPendentes.some(
          item => item.tipo === 'SPAP' && item.ano === anoReferencia
        );
        
        if (!existeSPAPAtual) {
          quotasPendentes = [];
        }
        
        groupQuotasByUser.push({
          userId: user.id,
          numero_socio: user.numero_socio,
          nameToSearch: newname,
          userStatus: user.status,
          quotasPendentes: quotasPendentes,
          name: (
            <>
              <div className="d-flex align-center">
                {newname}{" "}
                {newObs.length ? (
                  <Tooltip placement="top" title={newObs}>
                    <InfoCircleOutlined style={{ marginLeft: "10px" }} />
                  </Tooltip>
                ) : (
                  ""
                )}
              </div>
            </>
          ),
          email: user.email,
          registado_em: user.created_at,
          tipo_socio: user.tipo_socio,
          observ: newObs,
          quotas: updatedQuotas,
          nomeAMostrar: newname,
          quotasNaoPagas: (user.tipo_socio == 'Honorário') ? 0 : quotasPendentes.length,
          textPendentQuotas: quotasPendentes.length > 0 ? quotasPendentes.map(q => `${q.tipo} ${q.ano}`).join(", ") : ''
        });
      
    });

    setListUsersBkp(data.users);
    handleUsersWithPendentQuotas(groupQuotasByUser);
    setListaQuotas(groupQuotasByUser);
    setListaQuotasBkp(groupQuotasByUser);
    setDataToShow(() => getDataToShow(groupQuotasByUser));
  };

  useEffect(() => {
    getYears();
    fetchQuotas();
  }, []);

  const getYears = () => {
    let years = [];
    var currentYear = new Date().getFullYear();
    while (currentYear > 2020) {
      years.push({ text: currentYear, value: currentYear });
      currentYear--;
    }

    setYears(years);
  };

  const fetchQuotas = () => {
    fetch(`https://api.spap.pt/api/all-quotas`, {
      method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + session_storage.token,
        },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar anticorpos");
        }
        return response.json();
      })
      .then((data) => {
        getQuotas(data);
      })
      .catch((error) => console.error(error));
  };

  const handleSearchTable = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };


  const handleResetTable = clearFilters => {
    clearFilters();
    setSearchText('');
  };


  const [tablePagination, setTablePagination] = useState(25);

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearchTable(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearchTable(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Procurar
          </Button>
          <Button
            onClick={() => clearFilters && handleResetTable(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => {
            var _a;
            return (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.select();
          }, 100);
        }
      },
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  /* Table */
  const mainLastPaymentColumns = [
    {
      title: "Método",
      dataIndex: "payment_type",
      render: (text) => {
        return text === "MBWay" ? (
          <img src={MBWayImage} alt="MBWay" />
        ) : (
          <img src={MBImage} alt="MB" />
        );
      }
    },
    {
      title: "Email",
      dataIndex: "user_email"
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      width: '20%'
    },
    {
      title: "Valor",
      dataIndex: "valor",
    },
    {
      title: "ID Pagamento",
      dataIndex: "payment_id",
    },
    {
      title: "Data de pagamento",
      dataIndex: "payment_valid_date",
      render: (value) => {
        if (value.length < 10) return "-";

        const date = dayjs(value);
        if (!date.isValid()) return "-"; // <-- check for invalid date

        const hasTime = value.includes("T") || value.includes(" ");
        return hasTime
          ? date.format("DD-MM-YYYY HH[h]mm[m]")
          : date.format("DD-MM-YYYY");
      },

    },
    {
      title: "Documentos",
      render: (quota) => {
        const invoiceId = quota.invoiceId;
        const receipt = quota.receipt;

        // Verifica se o recibo existe primeiro, depois o invoiceId
        if (receipt && receipt != 'NULL') {
          return (
            <Button href={"https://api.spap.pt/recibos/" + receipt} download>
              <b>Fatura</b>
            </Button>
          );
        }
        if (quota.invoice_id != 'NULL' && quota.invoice_id?.length > 4) {
          return (
            <Button href={'https://api.spap.pt/api/invoice/' + quota.invoice_id + '/download'} download>
              <b>Fatura</b>
            </Button>
          );
        }

        // Se não houver recibo ou invoiceId, não renderiza nada
        return '';
      }
    },
  ];
  const mainColumns = [
    {
      title: "Nome",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Data de registo",
      dataIndex: "registado_em",
      render: (value) => {
        const date = new Date(value);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "Tipo de sócio",
      dataIndex: "tipo_socio",
    },
    {
      title: "Estado",
      dataIndex: 'status',
      filters: [
        {
          text: 'Ativo',
          value: '1',
        },
        {
          text: 'Inativo',
          value: '0',
        },
      ],
      onFilter: (value, record) => record.status == value,
      render: (_, record) => (
        <>
        { record.status == 1 && <>{'Ativo'}</> }
        { record.status != 1 && <>{'Inativo'}</> }
        </>
      ),
    },
    {
      title: "Nº de Sócio",
      dataIndex: "numero_socio",
    },
  ];
  const expandedColumns = [
    {
      title: "Ano",
      dataIndex: "ano",
      filters: years,
      onFilter: (value, record) => {
        return record.ano == value;
      },
    },
    {
      title: "Tipo de Quota",
      width: "14%",
      dataIndex: "tipo",
      filters: [
        {
          text: "SPAP",
          value: "SPAP",
        },
        {
          text: "ESP",
          value: "ESP",
        },
        {
          text: "IAP",
          value: "IAP",
        },
      ],
      onFilter: (value, record) => {
        return record.tipo == value;
      },
    },
    {
      title: "Valor",
      dataIndex: "valor",
    },
    {
      title: "Data de pagamento",
      dataIndex: "payment_valid_date",
      width: "14%",
      render: (value) => {
        if (value.length < 10) return "Não definido";

        const date = dayjs(value);
        if (!date.isValid()) return "-"; // <-- check for invalid date

        const hasTime = value.includes("T") || value.includes(" ");
        return hasTime
          ? date.format("DD-MM-YYYY HH[h]mm[m]")
          : date.format("DD-MM-YYYY");
      },
    },
    {
      title: "Estado",
      dataIndex: "estado",
      width: "14%",
    },
    {
      title: "Ficheiros",
      render: (quota) => {
        const invoiceId = quota.invoiceId;
        const receipt = quota.receipt;

        // Verifica se o recibo existe primeiro, depois o invoiceId
        if (receipt && receipt != 'NULL') {
          return (
            <Button href={"https://api.spap.pt/recibos/" + receipt} download>
              <b>Fatura</b>
            </Button>
          );
        }
        if (invoiceId) {
          return (
            <Button href={`https://api.spap.pt/api/invoice/${invoiceId}/download`} download>
              <b>Fatura</b>
            </Button>
          );
        }

        // Se não houver recibo ou invoiceId, não renderiza nada
        return '';
      }
    },
    {
      title: "Ações",
      dataIndex: "actions",
    },
  ];

  const columnsPendentQuotas = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Quotas por pagar",
      dataIndex: "quotasNaoPagas",
      key: "quotasNaoPagas",
    },
  ];

  const getDataToShow = (quotasAListar = []) => {
    if (quotasAListar?.length == 0) {
      quotasAListar = listaQuotas;
    }
    let data = [];
    for (let i = 0; i < quotasAListar.length; i++) {
      data.push({
        key: quotasAListar[i].userId,
        observ: quotasAListar[i].observ,
        nameSearch: quotasAListar[i].nameToSearch,
        name: <b>{quotasAListar[i].name}</b>,
        email: quotasAListar[i].email,
        registado_em: quotasAListar[i].registado_em,
        tipo_socio: quotasAListar[i].tipo_socio,
        status: quotasAListar[i].userStatus,
        numero_socio: quotasAListar[i].numero_socio
          ? quotasAListar[i].numero_socio
          : "-",
        observacoes: quotasAListar[i].obs ? quotasAListar[i].obs : "-",
        quotas: quotasAListar[i].quotas,
        quotasNaoPagas: quotasAListar[i].quotasNaoPagas,
        textPendentQuotas: quotasAListar[i].textPendentQuotas,
      });
    }

    return data;
  };

  const handleReset = () => {
    document.querySelector('input[name="searchable"]').value = '';
    setDataToShow(() => getDataToShow(quotasBkp));
    setListaQuotas(quotasBkp);
  };


  const handleResetLastPayments = () => {
    document.querySelector('input[name="last-searchable"]').value = '';
    setLastPaymentsToShow(lastPaymentsToShowBkp);
  };



  const handleSearch = () => {
    let allQuotas = quotasBkp;
    let input = document.querySelector('input[name="searchable"]')?.value.toLowerCase();
    if (input.length == 0) {
      setListaQuotas(quotasBkp);
      setDataToShow(() => getDataToShow(quotasBkp));
      return;
    }
    let novasQuotasAListar = allQuotas.filter((quota) => {
      if (
        quota.email?.toLowerCase().includes(input) ||
        quota.nameToSearch?.toLowerCase().includes(input) ||
        quota.observ.toString()?.toLowerCase().includes(input) ||
        quota.numero_socio?.toLowerCase().includes(input) ||
        quota.tipo_socio?.toLowerCase().includes(input)
      ) {
        return quota;
      }
    });
    setDataToShow(() => getDataToShow(novasQuotasAListar));
  };

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 500,
    rtl: false,
  });

  const handleSearchUsers = (value) => {
    setSearchTerm(value.toLowerCase());
  };


  const handleSearchLastPayments = (value) => {
    setSearchTerm2(value.toLowerCase());
  };


  const handleSearchQuotas = (value) => {
    setSearchTerm1(value.toLowerCase());
  };

  const filteredUsers = usersPendentQuotas.filter((user) =>
    user.nameToSearch.toLowerCase().includes(searchTerm) || 
    user.email.toLowerCase().includes(searchTerm)
  );

  const filteredLastPayments = lastPaymentsToShow.filter((payment) =>
    payment.payment_type?.toLowerCase().includes(searchTerm2) || 
    payment.payment_id?.includes(searchTerm2) || 
    payment.user_email.toLowerCase().includes(searchTerm2) || 
    payment.valor.toLowerCase().includes(searchTerm2)
  );

  const filteredQuotas = dataToShow.filter((quota) =>
    quota.nameSearch?.toLowerCase().includes(searchTerm1) || 
    quota.email.toLowerCase().includes(searchTerm1) || 
    quota.numero_socio.toLowerCase().includes(searchTerm1)
  );

  const rowSelection = {
    type: "radio",
    selectedRowKeys: selectedRowKey !== null ? [selectedRowKey] : [],
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRowKey(selectedKeys[0]);
    },
  };

  const prop = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };

  const hideModalReceipt = () => {
    setIsModalReceiptOpen(false);
  };
  const hideModalOutOfWebsite = () => {
    setIsModalOutOfWebsiteOpen(false);
  };

  const [value, setValue] = useState(1);

  useEffect(() => {
    if (dataDrawer?.type === 'payment') {
      setIsModalReceiptOpen(true);
    }
  }, [dataDrawer]);

  const setPaymentOutOfWebsite = (record) => {

    const pendentQuotas = record.textPendentQuotas.split(',').map(item => item.trim());
    let thisUser = listUsersBkp.filter((user) => { return user.email == record.email})[0];
    let dataPayment = {};

    dataPayment.quotas = pendentQuotas;
    dataPayment.email = record.email;
    dataPayment.name = record.nameSearch;

    let dataDrawerShow = {};

    dataDrawerShow.displayName = thisUser.nome_faturacao ?? record.nameSearch;
    dataDrawerShow.contribuinte = thisUser.nif_instituicao ?? thisUser.numero_contribuinte;
    dataDrawerShow.codigo_postal = thisUser.codigo_postal ?? '';
    dataDrawerShow.cidade = thisUser.cidade ?? '';
    dataDrawerShow.pais = thisUser.pais;
    dataDrawerShow.email = thisUser.email;
    dataDrawerShow.morada = thisUser.morada;
    dataDrawerShow.id = thisUser.id; 
    dataDrawerShow.emitirFatura = true;
    
    setDataDrawer(dataDrawerShow);
    setDataPayment(dataPayment);

    setIsModalOutOfWebsiteOpen(true);
  };  

  const handleOpenPaymentModal = () => {
    let quotasUser = usersPendentQuotas.filter((user) => { return user.userId == selectedRowKey})[0];
    let thisUser = listUsersBkp.filter((user) => { return user.id == selectedRowKey})[0];

    // percorrer quotas
    let pendentQuotas = quotasUser.quotas.filter((quota) => { return quota.status == 'nao pago'});

    const anoAtual = new Date().getFullYear();
    const mesAtual = new Date().getMonth() + 1;
    
    const filteredQuotas = pendentQuotas.filter(({ ano, mes, tipo }) => {
      const cond1 = ano < anoAtual && mes !== 12;
      const cond2 = ano === anoAtual && mes === 12;

      // Regras especiais para ESP baseadas no mês atual
      if (tipo === "ESP") {
        const isValido =
          (mesAtual == 12 && ano == anoAtual + 1) || // Dezembro → ano tem de ser o próximo
          ((mesAtual == 1 || mesAtual == 2) && ano == anoAtual); // Jan/Fev → ano atual

        if (!isValido) {
          return false; // Ignora ESP se não atender às condições
        }
      }

      return true;
    });


    const somaValores = filteredQuotas.reduce((acc, { valor, tipo }) => {
      let numero = Number(valor);

      if (isNaN(numero)) {
        if (tipo == 'SPAP') {
          numero = 30;
        } else if (tipo == 'ESP') {
          // Só considera ESP se o mês atual for Dezembro (12), Janeiro (1) ou Fevereiro (2)
          numero = (mesAtual === 12 || mesAtual === 1 || mesAtual === 2) ? 40 : 0;
        } else {
          numero = 0;
        }
      }

      return Number(acc) + Number(numero);
    }, 0);

    const quotasPendentesPorAno = filteredQuotas
      .filter(({ ano, mes, tipo }) => {
        const cond1 = ano < anoAtual && mes !== 12;
        const cond2 = ano === anoAtual && mes === 12;
        let tipoIgnorado = tipo === 'IAP';

        // ESP só é considerado de Dezembro a Fevereiro
        if (tipo === 'ESP' && !(mesAtual === 12 || mesAtual === 1 || mesAtual === 2)) {
          tipoIgnorado = true;
        }

        return !((cond1 || cond2) && tipoIgnorado);
      })
      .map(({ tipo, ano }) => ({ tipo, ano }));


    let dataDrawerShow = {};
    dataDrawerShow.displayName = quotasUser.nameToSearch;
    dataDrawerShow.tipo = quotasUser.quotasNaoPagas;
    dataDrawerShow.valor = somaValores;
    dataDrawerShow.contribuinte = thisUser.nif_instituicao ?? thisUser.numero_contribuinte;
    dataDrawerShow.codigo_postal = thisUser.codigo_postal ?? '';
    dataDrawerShow.cidade = thisUser.cidade ?? '';
    dataDrawerShow.pais = thisUser.pais;
    dataDrawerShow.email = thisUser.email;
    dataDrawerShow.morada = thisUser.morada;
    dataDrawerShow.id = thisUser.id;
    dataDrawerShow.listQuotas = quotasPendentesPorAno;
    dataDrawerShow.type = 'payment';
    


    setDataDrawer(dataDrawerShow);
  };  



  const filtrarPorData = (dates) => {
    if (!dates || dates.length !== 2) {
      setLastPaymentsToShow(lastPaymentsToShowBkp);
      return;
    }

    const [start, end] = dates;

    const filtrados = lastPaymentsToShowBkp.filter(item => {
      const dataItem = item.payment_valid_date ? item.payment_valid_date.slice(0, 10) : null;
      if (!dataItem) return false;

      return (
        dayjs(dataItem).isSameOrAfter(start, 'day') &&
        dayjs(dataItem).isSameOrBefore(end, 'day')
      );
    });

    setLastPaymentsToShow(filtrados);
  };


  const items = [
  {
    key: '1',
    label: 'Últimos pagamentos',
    children: <><Card className="card-payments">

          <CardHeader className="mb-10">
            <Title>Últimos pagamentos</Title>
            <Space size={28}>
              <Search
                className="back-input"
                style={{ width: "500px"}}
                placeholder="Procurar..."
                onSearch={(e) => handleSearchLastPayments(e.target.value)}
                onChange={(e) => handleSearchLastPayments(e.target.value)}
                enterButton
              />
              <RangePicker
                onChange={filtrarPorData}
                allowClear
                style={styles.input_class}
                placeholder={['Data inicial', 'Data final']}
              />
              <IconOptions
                className="icon icon-options"
                ref={ref1}
                onClick={() => setOpen(true)}
              />
              <IconUpload
                className="icon icon-upload"
                ref={ref2}
              />
            </Space>
          </CardHeader>
          <CardContent>
            <Table
              columns={mainLastPaymentColumns}
              onRow={(record, index) => ({
                style: {
                  background: record.pagamentoNoDiaAtual == true ? "rgb(232, 233, 243)" : "#fff",
                },
              })}
              dataSource={filteredLastPayments}
              onChange={tableOnChange}
              pagination={{
                pageSize: pageSize,
                showSizeChanger: true,
                locale: { items_per_page: " / página" },
                pageSizeOptions: ["10", "25", "50"],
                onShowSizeChange: (_, newSize) => setPageSize(newSize),
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
          </CardContent>
        </Card></>
  },
  {
    key: '2',
    label: 'Listagem de quotas por utilizador',
    children: <>
      <Card>
          <CardHeader className="mb-10">
            <Title>Quotas por utilizador</Title>
            <Space size={28}>
              <Search
                className="back-input"
                style={{ width: "500px"}}
                placeholder="Procurar..."
                onSearch={(e) => handleSearchQuotas(e.target.value)}
                onChange={(e) => handleSearchQuotas(e.target.value)}
                enterButton
              />
              <IconOptions
                className="icon icon-options"
                ref={ref1}
                onClick={() => setOpen(true)}
              />
              <IconUpload
                className="icon icon-upload"
                ref={ref2}
                onClick={() => setIsModalOpen(true)}
              />
            </Space>
          </CardHeader>
          <CardContent>
            <Table
              columns={mainColumns}
              onRow={(record, index) => ({
                style: {
                  background: record.quotasNaoPagas > 0 ? "#ffdddd" : "#ddffdd",
                },
              })}
              rowClassName={(record, index) =>
                record.quotasNaoPagas > 0 ? "table-danger" : "table-success"
              }
              expandable={{
                // rowExpandable: (record) => record.quotas.length > 0,
                expandedRowRender: (record) => (
                  <>
                  {record.textPendentQuotas &&
                    <><Row align={'middle'} justify="start" gutter={[20,20]} className="mb-3"><p style={{ textDecoration: 'none', marginBottom: '0', paddingLeft: '10px'}}><b>Quotas por pagar:</b> {record.textPendentQuotas}</p> &nbsp;&nbsp;&nbsp;<Button onClick={() => setPaymentOutOfWebsite(record)}>Gerar pagamento</Button></Row></>}
                    <TextArea
                      key={"observ-" + record.userId}
                      defaultValue={record.observ}
                      name={"observ-" + record.key}
                      style={{ marginBottom: "10px" }}
                      placeholder="Inserir observações"
                    />
                    <Button
                      key={"submitObs" + record.userId}
                      onClick={() => handleSubmitObs(record.key, record.email)}
                      style={{ float: "right", display: "block" }}
                    >
                      Guardar
                    </Button>
                    <br />
                    <Table
                      bodySortBg
                      columns={expandedColumns}
                      dataSource={handleQuotasData(
                        record.quotas,
                        record.nameToSearch
                      )}
                      onChange={tableOnChange}
                      pagination={false}
                      rowClassName={(record, index) =>
                        record.estado == "Não pago" && record.tipo == "SPAP"
                          ? "table-warning"
                          : ""
                      }
                    />
                  </>
                ),
              }}
              dataSource={filteredQuotas}
              onChange={tableOnChange}
              pagination={{
                pageSize: pageSize,
                showSizeChanger: true,
                locale: { items_per_page: " / página" },
                pageSizeOptions: ["10", "25", "50"],
                onShowSizeChange: (_, newSize) => setPageSize(newSize),
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
          </CardContent>
        </Card>
        </>
  },
  // {
  //   key: '3',
  //   label: <><img src={MBImage1} width="20px" alt="MB" />&nbsp; Gerar pagamento</>,
  //   children: <>
  //     <Card>
  //         <CardHeader >
  //           <Title className="p-15-0">Gerar pagamento via Multibanco</Title>
  //             <Search
  //               className="back-input"
  //               style={{ width: "500px"}}
  //               placeholder="Procurar..."
  //               onSearch={(e) => handleSearchUsers(e.target.value)}
  //               onChange={(e) => handleSearchUsers(e.target.value)}
  //               enterButton
  //             />
  //             <Button className="export-btn"  disabled={selectedRowKey ? false : true} onClick={() => handleOpenPaymentModal()}>Gerar pagamento</Button>
              
  //         </CardHeader>
  //         <CardContent>
  //           <Space direction="vertical" style={{ width: "100%" }}>

  //             <Table
  //               rowKey="userId"
  //               columns={columnsPendentQuotas}
  //               dataSource={filteredUsers}
  //               rowSelection={rowSelection}
  //             pagination={{
  //               pageSize: pageSize,
  //               showSizeChanger: true,
  //               locale: { items_per_page: " / página" },
  //               pageSizeOptions: ["10", "25", "50"],
  //               onShowSizeChange: (_, newSize) => setPageSize(newSize),
  //               showTotal: (total, range) =>
  //                 `${range[0]}-${range[1]} of ${total} items`,
  //             }}
  //             />
  //           </Space>
  //         </CardContent>
  //       </Card>
  //       </>
  // },
];

  const steps = [
    {
      title: "Como fazer o upload dos pagamentos das quotas?",
      description:
        "É necessário seguir a ordem das colunas do CSV em formato UTF-8 do ficheiro fornecido em cima.",
      cover: (
        <div style={{ marginBottom: "10px" }}>
          <a
            href="https://api.spap.pt/uploads/ficheiro-template-quotas.csv"
            style={{
              padding: "12px 40px",
              textDecoration: "none",
              borderRadius: "6px",
              backgroundColor: "#494D7D",
              color: "#fff",
            }}
            download
          >
            Download do ficheiro template
          </a>
        </div>
      ),
      target: () => ref1.current,
    },
    {
      title: "Momento de fazer upload",
      description:
        "Assim que desejar fazer o upload do pagamento das quotas, basta clicar neste botão e será aberta uma modal com um campo para arrastar o ficheiro ou clicar para o introduzir manualmente.",
      target: () => ref2.current,
    },
    {
      title: "Fim",
      description: "Espero que tenha sido util!",
      target: () => ref2.current,
    },
  ];
  const handleUpload = () => {
    readString(fileList[0], {
      worker: true,
      complete: (results) => {
        if (results.data.length == 0) {
          notification.error({
            description: "O Ficheiro não tem quotas para inserir.",
          });
        } else {
          var bodyFormData = new FormData();
          bodyFormData.append("array", JSON.stringify(results.data));
          setUploading(true);
          fetch("https://api.spap.pt/api/admin/upload-quotas", {
            method: "POST",
            body: bodyFormData,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + session_storage.token,
            },
          }).then((response) => {
            response.json().then((data) => {
              if (data.message == "array_error") {
                notification.error({
                  description: "ERRO! O Ficheiro tem campos por preencher.",
                });
              } else {
                getQuotas(data);
                setIsModalOpen(false);
                notification.success({
                  description: "O ficheiro foi inserido com sucesso!",
                });
              }
              setFileList([]);
              setUploading(false);
            });
          });
        }
      },
    });
  };

  const generateReceipt = () => {
    let name = document.querySelector('input[name="receipt-name"]').value;
    let value = document.querySelector('input[name="receipt-value"]').value;
    let vat = document.querySelector('input[name="receipt-vat"]').value;
    let address = document.querySelector('input[name="receipt-address"]').value;
    let postalCode = document.querySelector('input[name="receipt-post"]').value;
    let city = document.querySelector('input[name="receipt-city"]').value;
    let country = document.querySelector('input[name="receipt-country"]').value;

    if (!name || !vat || !address || !postalCode || !city || !country) {
      notification.warning({
        description: "Precisa de preencher todos os campos",
      });
    }  
    
    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', dataDrawer.user_email);
    formData.append('type', type);
    formData.append('year', year);
    formData.append('value', value);
    formData.append('vat', vat);
    formData.append('address', address);
    formData.append('postalCode', postalCode);
    formData.append('city', city);
    formData.append('country', country);
    formData.append('tipo', dataDrawer.tipo);
    formData.append('ano', dataDrawer.ano);


    setLoading(true);

    fetch("https://api.spap.pt/api/admin/generate-receipt", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        fetchQuotas();
        setIsModalReceiptOpen(false);
        setLoading(false);
        notification.success({
          description: "A fatura foi criada com sucesso!",
        });
        let thisReceipt = [
          {
            uid: "-1",
            name: 'Recibo',
            status: "done",
            url: `https://api.spap.pt/api/invoice/${data.invoice_id}/download`,
            thumbUrl: `https://api.spap.pt/api/invoice/${data.invoice_id}/download`,
          },
        ];
        setfileRecibo(thisReceipt);   
      });
    });
  };

  const generateQuotaText = (quotasArray) => {
    const now = new Date();
    let currentYear = now.getFullYear();

    // Se for dezembro, ano atual = ano seguinte
    if (now.getMonth() === 11) {
      currentYear = currentYear + 1;
    }

    // -- 2. Extrair só os anos do array
    const quotasParsed = quotasArray.map(q => {
      const [type, year] = q.split(" ");
      return { type, year: parseInt(year) };
    });

    // -- 3. Verificar se SPAP e ESP do ano atual existem
    const hasSPAP = quotasParsed.some(q => q.type === "SPAP" && q.year === currentYear);
    const hasESP  = quotasParsed.some(q => q.type === "ESP"  && q.year === currentYear);

    // -- 4. Construir a frase da quota atual
    const currentText =
      hasSPAP && hasESP
        ? `Quota SPAP+ESP ${currentYear}`
        : hasSPAP
        ? `Quota SPAP ${currentYear}`
        : hasESP
        ? `Quota ESP ${currentYear}`
        : null;

    // -- 5. Quotas pendentes (anos < ano atual)
    const pendingYears = [
      ...new Set(
        quotasParsed
          .filter(q => q.year < currentYear)
          .map(q => q.year)
      )
    ].sort();

    const pendingText = pendingYears.length
      ? `quotas pendentes ${pendingYears.join(", ")}`
      : null;

    // -- 6. Construir texto final
    if (currentText && pendingText) {
      return `${currentText} e ${pendingText}`;
    } else if (currentText) {
      return currentText;
    } else if (pendingText) {
      return pendingText;
    }

    return "Sem quotas disponíveis";
  };

  const calcularTotalQuotas = (quotasArray) => {
    let total = 0;

    quotasArray.forEach((q) => {
      if (q.startsWith("SPAP")) {
        total += 30;
      } else if (q.startsWith("ESP")) {
        total += 40;
      }
    });

    return total;
  };

  const generatePaymentAndReceipt = () => {

    if (!dataDrawer.valid_date ||
        !dataDrawer.tipos.length ||
        !dataDrawer.displayName ||
        !dataDrawer.morada ||
        !dataDrawer.codigo_postal ||
        !dataDrawer.cidade ||
        !dataDrawer.contribuinte) 
    {
      notification.warning({
        description: "Precisa de preencher todos os campos",
      });
      return;
    }

    let desc = generateQuotaText(dataDrawer.tipos);
    let arrayData = dataDrawer.tipos.map((quota) => {
      const [tipoRaw, ano] = quota.split(" ");
      const tipo = tipoRaw.toUpperCase();

      let valor = 0;
      if (tipo === 'SPAP') valor = 30;
      if (tipo === 'ESP') valor = 40;

      return {
        tipo,
        ano,
        valor
      };
    });

    let amount = calcularTotalQuotas(dataDrawer.tipos);

    const formData = new FormData();
    formData.append('name', dataDrawer.displayName);
    formData.append('email', dataDrawer.email);
    formData.append('vat', dataDrawer.contribuinte);
    formData.append('address', dataDrawer.morada);
    formData.append('postalCode', dataDrawer.codigo_postal);
    formData.append('description', desc);
    formData.append('listQuotas', JSON.stringify(arrayData));
    formData.append('city', dataDrawer.cidade);
    formData.append('amount', amount);
    formData.append('country', dataDrawer.pais);
    formData.append('payment_date', dataDrawer.valid_date);
    formData.append('generate_receipt', dataDrawer.emitirFatura);

    setLoading(true);

    fetch("https://api.spap.pt/api/admin/generate-payment-receipt", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
          notification.success({
            description: "Pagamento adicionado e fatura gerada com sucesso!",
          });
        fetchQuotas();  
        setIsModalOutOfWebsiteOpen(false);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
    };


  useEffect(() => {
    form.setFieldsValue(dataDrawer);
  }, [form, dataDrawer]);

  const onFormInputChange = (prop, values) => {
    setDataDrawer(values);
  };
  const openQuotaDrawer = (quota) => {
    setfileRecibo([]);
    setfileNotaCredito([]);
    setfileComprovativo([]);

    let quotaDrawer = quota;
    
    quotaDrawer.contribuinte = quotaDrawer.nif_instituicao ?? quotaDrawer.numero_contribuinte;
    quotaDrawer.codigo_postal = quotaDrawer.codigo_postal ?? '';
    quotaDrawer.cidade = quotaDrawer.cidade ?? '';
    quotaDrawer.pais = quotaDrawer.pais;
    quotaDrawer.email = quotaDrawer.email;
    quotaDrawer.morada = quotaDrawer.morada;

    quotaDrawer.valid_date =
      quotaDrawer?.payment_valid_date != null
        ? quotaDrawer.payment_valid_date.slice(0, 10)
        : "";

    quotaDrawer.phone = quotaDrawer.phone != "null" ? quotaDrawer.phone : "";
    quotaDrawer.payment_type =
      quotaDrawer.payment_type == "" || quotaDrawer.payment_type == "null" ? [] : quotaDrawer.payment_type;
    quotaDrawer.reference =
      quotaDrawer.reference != "null" ? quotaDrawer.reference : "";
    quotaDrawer.description = quotaDrawer.description == "" || quotaDrawer.description == "null" ? '' : quotaDrawer.description;
    if (quota.payment_file_proof && quota.payment_file_proof != 'NULL') {
      let thisProof = [
        {
          uid: "-1",
          name: quota.payment_file_proof,
          status: "done",
          url: "https://api.spap.pt/comprovantes/" + quota.payment_file_proof,
          thumbUrl:
            "https://api.spap.pt/comprovantes/" + quota.payment_file_proof,
        },
      ];
      setfileComprovativo(thisProof);
    }
    if (quota.payment_file_receipt && quota.payment_file_receipt != 'NULL') {
      let thisReceipt = [
        {
          uid: "-1",
          name: quota.payment_file_receipt,
          status: "done",
          url: "https://api.spap.pt/recibos/" + quota.payment_file_receipt,
          thumbUrl: "https://api.spap.pt/recibos/" + quota.payment_file_receipt,
        },
      ];
      setfileRecibo(thisReceipt);
    } else {
      let thisReceipt = [
        {
          uid: "-1",
          name: 'Recibo',
          status: "done",
          url: `https://api.spap.pt/api/invoice/${quota.invoice_id}/download`,
          thumbUrl: `https://api.spap.pt/api/invoice/${quota.invoice_id}/download`,
        },
      ];
      setfileRecibo(thisReceipt);   
    }
    if (quota.payment_file_credit && quota.payment_file_credit != 'NULL') {
      let thisCredit = [
        {
          uid: "-1",
          name: quota.payment_file_credit,
          status: "done",
          url: "https://api.spap.pt/notaCredito/" + quota.payment_file_credit,
          thumbUrl:
            "https://api.spap.pt/notaCredito/" + quota.payment_file_credit,
        },
      ];
      setfileNotaCredito(thisCredit);
    }
    quotaDrawer.displayName = quotaDrawer?.name?.props?.children?.props
      .children[0]
      ? quotaDrawer?.name?.props?.children?.props.children[0]
      : quotaDrawer.name;


    quotaDrawer.contribuinte = (!quotaDrawer?.contribuintePessoal?.length > 9)
      ? quotaDrawer?.contribuintePessoal
      : quotaDrawer.contribuinteInstituicao;
    setUserDrawer(quotaDrawer);

    setDataDrawer(quotaDrawer);

    form.setFieldsValue(quotaDrawer);

    setShowDrawer(true);
  };

  const handleSaveQuota = () => {
    const formData = new FormData();
    Object.keys(dataDrawer).forEach((key) => {
      formData.append(key, dataDrawer[key]);
    });
    if (fileComprovativo.length) {
      formData.append("proof", fileComprovativo[0]);
    }
    if (fileRecibo.length) {
      formData.append("receipt", fileRecibo[0]);
    }
    if (fileNotaCredito.length) {
      formData.append("credit", fileNotaCredito[0]);
    }
    fetch("https://api.spap.pt/api/admin/update-quota", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        if (data.message == "success") {
          notification.success({
            description: "A quota foi atualizada com sucesso!",
          });
        }
        data.newData.name = dataDrawer?.displayName;
        openQuotaDrawer(data.newData);
        fetchQuotas();
      });
    });
  };

  const handleQuotasData = (quotas, userName) => {
    let data = [];
    for (let i = 0; i < quotas.length; i++) {
      quotas[i].id = quotas[i].id;
      quotas[i].name = userName;
      if (quotas[i].tipo != "IAP") {
        data.push({
          key: quotas[i].id,
          ano: quotas[i].ano,
          tipo: quotas[i].tipo,
          valor: Number(quotas[i].valor) ? quotas[i].valor + " €" : "N/A",
          estado: quotas[i].status == "pago" ? "Pago" : "Não pago",
          payment_valid_date:
            quotas[i].payment_valid_date == "NULL" ||
            quotas[i].payment_valid_date == null
              ? "N/A"
              : quotas[i].payment_valid_date,
          invoiceId: quotas[i].invoice_id,
          receipt: quotas[i].payment_file_receipt,
          actions: (
            <>
              <Button
                type="primary"
            icon={<EditOutlined />}
                key={"editBtn" + quotas[i].id}
                onClick={() => openQuotaDrawer(quotas[i])}
              >
                Editar
              </Button>
            </>
          ),
        });
      }
    }

    return data;
  };

  const handleGenerateMB = () => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      let userId = dataDrawer.id;

      do {
        userId = `0${userId}`;
      } while (userId.length < 4);

      let orderId = `${dayjs().format("YYYYMMDDHHmmss")}${userId}`;

      let data = {
        userId: dataDrawer.id,
        orderId: orderId,
        amount: dataDrawer.valor,
        description: dataDrawer.tipo,
        userName: dataDrawer.displayName,
        userEmail: dataDrawer.email,
        listQuotas: dataDrawer.listQuotas,
      };

      axios
        .post("https://api.spap.pt/api/purchaseMB", {
          data: data,
        })
        .then((res) => {
          notification.success({
            description: "O pagamento foi gerado e o utilizador receberá um email com os dados relativos ao mesmo.",
          });      
          setLoading(false);
          setIsModalReceiptOpen(false);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  const handleReceipt = () => {
    if (dataDrawer.valid_date.length != 10) {
      notification.error({
        description: "Necessita de inserir a data de pagamento.",
      });      
      return;
    }

    setIsModalReceiptOpen(true);
  }

  const handleSubmitObs = (userId, email) => {
    let text = document.querySelector(
      'textarea[name="observ-' + userId + '"]'
    ).value;
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("text", text);
    fetch("https://api.spap.pt/api/admin/update-observ", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        if (data.message == "success") {
          notification.success({
            description: "A observação foi atualizada com sucesso!",
          });
          fetchQuotas();
        }
      });
    });
  };

  return (
    <Wrapper>
      <div>
        <Sidebar />
      </div>
      <Content>
        <Header />
          <Tabs defaultActiveKey="1" items={items}  />
        
        <CardQuotes />
        {/* <QuotasPrices /> */}
        <Footer />
        <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
        <Modal
          key={"upload-quota"}
          open={isModalOpen}
          width={300}
          onCancel={hideModal}
          footer={[
            <Button
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0}
              loading={uploading}
              style={{
                borderRadius: "12px",
                background: "#494D7D",
                width: "100%",
                height: "45px",
                color: "#fff"
              }}
            >
              {uploading ? "Uploading" : "Fazer Upload"}
            </Button>,
          ]}
        >
          <h5
            style={{
              marginBottom: 0,
              fontSize: "18px",
              textAlign: "center",
              paddingTop: "20px",
              paddingBottom: "10px",
            }}
          >
            Faça upload do ficheiro
          </h5>
          <p
            style={{
              marginBottom: 0,
              fontSize: "14px",
              textAlign: "center",
              color: "#809FB8",
              paddingBottom: "2px",
            }}
          ></p>
          <Dragger {...prop} style={{ borderRadius: "12px" }}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Clique ou arraste para aqui o ficheiro relativo às quotas que
              pretende associar.
            </p>
          </Dragger>
        </Modal>
        <Modal
  key={"modal-payment-receipt-" + userDrawer?.id}
  open={isModalOutOfWebsiteOpen}
  width={800}
  title={'Dados do pagamento efetuado'}
  onCancel={hideModalOutOfWebsite}
  footer={[
    <Spin spinning={loading}>
      <Button
        type="primary"
        onClick={generatePaymentAndReceipt}
        style={{
          marginTop: "10px",
          borderRadius: "8px",
          background: "#494D7D",
          width: "100%",
          height: "45px",
          color: "#fff"
        }}
      >
        Adicionar pagamento e gerar respetiva fatura
      </Button>
    </Spin>,
  ]}
>
  <Row gutter={[8, 8]}>

    <Col span={24}>
      <p className="mb-0 mt-10"><b>Tipo de Quotas</b></p>
      <Select
        placeholder="Selecione uma quota"
        style={{ width: "100%", height: "35px", lineHeight: "35px" }}
        mode="multiple"
        value={dataDrawer.tipos || []} 
        onChange={(values) => {
          setDataDrawer({
            ...dataDrawer,
            tipos: values  
          });
        }}
      >
        {dataPayment?.quotas.map((quota, idx) => (
          <Option key={idx} value={quota}>
            {quota}
          </Option>
        ))}
      </Select>
    </Col>


    <Col span={12}>
            <p className="mb-0"><b>Nome</b></p>
            <Input name="receipt-name" className="input-generate-receipt"
              value={dataDrawer.displayName || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, displayName: e.target.value })} />
          </Col>
          <Col span={12}>
            <p className="mb-0"><b>Email</b></p>
            <Input name="receipt-type" className="input-generate-receipt"
              value={dataDrawer.email || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, email: e.target.value })} />
          </Col>
          <Col span={24}>
            <p className="mb-0 mt-10"><b>Morada</b></p>
            <Input name="receipt-address" className="input-generate-receipt"
              value={dataDrawer.morada || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, morada: e.target.value })} />
          </Col>
          <Col span={12}>
            <p className="mb-0 mt-10"><b>Código Postal</b></p>
            <Input name="receipt-post" className="input-generate-receipt"
              value={dataDrawer.codigo_postal || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, codigo_postal: e.target.value })} />
          </Col>
          <Col span={12}>
            <p className="mb-0 mt-10"><b>Cidade</b></p>
            <Input name="receipt-city" className="input-generate-receipt" 
              value={dataDrawer.cidade || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, cidade: e.target.value })} />
          </Col>
          <Col span={12}>
            <p className="mb-0 mt-10"><b>Contribuinte</b></p>
            <Input name="receipt-vat" className="input-generate-receipt"
              value={dataDrawer.contribuinte || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, contribuinte: e.target.value })} />
          </Col>
          <Col span={12}>
            <p className="mb-0 mt-10"><b>Data de Pagamento</b></p>
            <DatePicker
              className="payment-date"
              style={{ height: '35px', width: '100%', border: '1px solid #ccc'}}
              placeholder="Selecione a data" 
              onChange={(date, dateString) => 
                setDataDrawer({ ...dataDrawer, valid_date: dateString })
              }
            />
          </Col>
          <Col span={24}>
            <Checkbox
              checked={dataDrawer.emitirFatura}
              onChange={(e) =>
                setDataDrawer({
                  ...dataDrawer,
                  emitirFatura: e.target.checked,
                })
              }
            >
              Emitir fatura automaticamente
            </Checkbox>
          </Col>
  </Row>
</Modal>


        <Modal
          key={"modal-payment-receipt-" + userDrawer?.id}
          open={isModalReceiptOpen}
          width={800}
          title={dataDrawer.type != 'payment' ? 'Dados da fatura' : 'Dados de pagamento'}
          onCancel={hideModalReceipt}
          footer={[
            <Spin spinning={loading}>
              <Button
                type="primary"
                onClick={dataDrawer.type != 'payment' ? generateReceipt : handleGenerateMB }
                style={{
                  borderRadius: "12px",
                  background: "#494D7D",
                  width: "100%",
                  height: "45px",
                  color: "#fff"
                }}
              >
                { dataDrawer.type != 'payment' ? 'Gerar fatura' : 'Gerar pagamento' }
              </Button>
            </Spin>,
          ]}
        >
          <Row gutter={[8,8]}>
          <p className="mb-0">&nbsp;Será enviado um email para o utilizador com os dados de pagamento de forma a realizar o pagamento via Multibanco.</p>
          <Col span={12}>
            <p className="mb-0"><b>Nome</b></p>
            <Input name="receipt-name" className="input-generate-receipt"
              value={dataDrawer.displayName || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, displayName: e.target.value })} />
          </Col>
          <Col span={12}>
            <p className="mb-0"><b>Email</b></p>
            <Input name="receipt-type" className="input-generate-receipt"
              value={dataDrawer.email || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, email: e.target.value })} />
          </Col>
          <Col span={7}>
            <p className="mb-0 mt-10"><b>Tipo</b></p>
            <Input disabled name="receipt-type" className="input-generate-receipt"
              value={dataDrawer.tipo || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, tipo: e.target.value })} />
          </Col>
          <Col span={5}>
            <p className="mb-0 mt-10"><b>Ano</b></p>
            <Input disabled name="receipt-year" className="input-generate-receipt"
              value={dataDrawer.ano || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, ano: e.target.value })} />
          </Col>
          <Col span={6}>
            <p className="mb-0 mt-10"><b>Valor (€)</b></p>
            <Input disabled name="receipt-value" className="input-generate-receipt"
              value={dataDrawer.valor || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, valor: e.target.value })} />
          </Col>
          <Col span={6}>
            <p className="mb-0 mt-10"><b>Contribuinte</b></p>
            <Input name="receipt-vat" className="input-generate-receipt"
              value={dataDrawer.contribuinte || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, contribuinte: e.target.value })} />
          </Col>
          <Col span={24}>
            <p className="mb-0"><b>Morada</b></p>
            <Input name="receipt-address" className="input-generate-receipt"
              value={dataDrawer.morada || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, morada: e.target.value })} />
          </Col>
          <Col span={dataDrawer.type != 'payment' ? 12 : 8}>
            <p className="mb-0 mt-10"><b>Código Postal</b></p>
            <Input name="receipt-post" className="input-generate-receipt"
              value={dataDrawer.codigo_postal || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, codigo_postal: e.target.value })} />
          </Col>
          <Col span={dataDrawer.type != 'payment' ? 12 : 8}>
            <p className="mb-0 mt-10"><b>Cidade</b></p>
            <Input name="receipt-city" className="input-generate-receipt" 
              value={dataDrawer.cidade || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, cidade: e.target.value })} />
          </Col>
          <Col span={dataDrawer.type != 'payment' ? 12 : 8}>
            <p className="mb-0 mt-10"><b>País</b></p>
            <Input name="receipt-country" className="input-generate-receipt" onChange={(e) => userDrawer.pais = e.target.value} defaultValue={userDrawer.pais}/>
          </Col>
          { dataDrawer.type != 'payment' && 
          <>
            <Col span={12}>
              <p className="mb-0 mt-10"><b>Data de Pagamento</b></p>
              <Input name="receipt-date" className="input-generate-receipt"
              value={dataDrawer.valid_date || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, valid_date: e.target.value })} />
            </Col>
            <Col span={24}>
              <p className="mb-0 mt-10"><b>Descrição</b></p>
              <Input name="receipt-description" className="input-generate-receipt"
              value={dataDrawer.description || ""}
              onChange={(e) => setDataDrawer({ ...dataDrawer, description: e.target.value })} />
            </Col>
          </>}
          </Row>
        </Modal>
      </Content>
      <Drawer
        title={"Editar Quota"}
        width={800}
        onClose={() => setShowDrawer(false)}
        open={showDrawer}
        bodyStyle={{
          paddingBottom: 80,
        }}
        extra={
          <Space>
            <Button onClick={() => setShowDrawer(false)}>Cancelar</Button>
            <Button
              onClick={handleSaveQuota}
              style={{
                borderRadius: "6px",
                background: "#494D7D",
                color: "#fff",
              }}
            >
              Guardar
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="horizontal"
          initialValues={dataDrawer}
          onValuesChange={onFormInputChange}
        >
          <Row gutter={[12, 8]}>
            <Form.Item name="id" style={{ marginBottom: "12px" }}>
              <Input style={styles.input_class} hidden />
            </Form.Item>
            <Col span={24}>
              <label className="text">Nome do Sócio</label>
              <Form.Item name="drawerName" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Ano</label>
              <Form.Item name={"ano"} style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Tipo de Quota</label>
              <Form.Item name="tipo" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Estado</label>
              <Form.Item name="status" style={{ marginBottom: "12px" }}>
                <Select
                  disabled
                  style={styles.select_class}
                  placeholder="Estado"
                  options={[
                    { value: "nao pago", label: "Não pago" },
                    { value: "pago", label: "Pago" },
                  ]}
                ></Select>
              </Form.Item>
            </Col>
          </Row>
          <Divider>Dados do pagamento</Divider>
          <Row gutter={[12, 18]} align="bottom">
            <Col span={8}>
              <label className="text">Valor (€)</label>
              <Form.Item name="valor" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Data de Pagamento</label>
              <br />
              <Form.Item name="valid_date" style={{ marginBottom: "12px" }}>
                <input type="date" style={styles.date_class} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Método de pagamento</label>
              <Form.Item name="payment_type" style={{ marginBottom: "12px" }}>
                <Select
                  placeholder="Método de pagamento"
                  style={styles.select_class}
                  options={[
                    { value: "MBWay", label: "MBWay" },
                    {
                      value: "Transferencia bancaria",
                      label: "Transferencia bancaria",
                    },
                    { value: "Multibanco", label: "Multibanco" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[12, 18]} align="bottom">
            <Col span={8}>
              <label className="text">Nº Telemóvel</label>
              <br />
              <Form.Item name="phone" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} placeholder="Nº Telemóvel" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Entidade</label>
              <br />
              <Form.Item name="entity" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} placeholder="Entidade" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <label className="text">Referência</label>
              <Form.Item name="reference" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} placeholder="Referência" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[12, 18]} align="bottom">
            <Col span={24}>
              <label className="text">Descrição</label>
              <br />
              <Form.Item name="description" style={{ marginBottom: "12px" }}>
                <Input style={styles.input_class} placeholder="Descrição" />
              </Form.Item>
            </Col>
          </Row>
          { dataDrawer.status == 'pago' &&
          <>
            <Divider>Ficheiros</Divider>
            <Row gutter={[12, 18]} className="pb-10">
              <Col span={8}>
                <Row justify={'space-between'} className="mb-0">
                <label className="text">Recibo</label>
                </Row>
                <Dragger
                  key={"recibo" + dataDrawer.id}
                  {...propReciboPDF}
                  fileList={fileRecibo}
                  style={{ borderRadius: "12px" }}
                  accept="application/pdf"
                >
                  <p className="ant-upload-text">Faça o upload do recibo</p>
                  <p className="ant-upload-hint">
                    Apenas ficheiros com formato PDF são permitidos
                  </p>
                </Dragger>

                 <Button onClick={() => handleReceipt()} className="w-100 export-btn mt-10 mb-10"><FileOutlined/> Gerar automaticamente</Button> 
              </Col>
              <Col span={8}>
                <label className="text">Nota de crédito</label>
                <br />
                <Dragger
                  key={"notaCredito" + dataDrawer.id}
                  {...propNotaCreditoPDF}
                  fileList={fileNotaCredito}
                  style={{ borderRadius: "12px" }}
                  accept="application/pdf"
                >
                  <p className="ant-upload-text">
                    Faça o upload da nota de crédito
                  </p>
                  <p className="ant-upload-hint">
                    Apenas ficheiros com formato PDF são permitidos
                  </p>
                </Dragger>
              </Col>
              <Col span={8}>
                <label className="text">Comprovativo</label>
                <br />
                <Dragger
                  key={"comprovativo" + dataDrawer.id}
                  {...propComprovativoPDF}
                  fileList={fileComprovativo}
                  style={{ borderRadius: "12px" }}
                  accept="application/pdf"
                >
                  <p className="ant-upload-text">Faça o upload do comprovativo</p>
                  <p className="ant-upload-hint">
                    Apenas ficheiros com formato PDF são permitidos
                  </p>
                </Dragger>
              </Col>
            </Row>
          </>
          }
        </Form>
      </Drawer>
    </Wrapper>
  );
}
